import { isEmptyScObj } from "../../utils/siteUtils";
import React, { useState } from "react";
import api from "../../utils/api";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import Input from "../../elements/input";
import { SuperButton } from "../../elements";
import ChangeEmailModal from "../../react-components/change-email-modal";
import ResetPassword from "../../components/ResetPassword";
import { selectUserState } from "../../selectors/application";
import { connect } from "react-redux";
import { sendResetPasswordLinkToEmail } from "../../services/userService";
import { LOGOUT } from "../../redux/actions";
import SelectVerificationMethodModal from "../../react-components/select-verification-method-modal";
import { getVerificationMethods } from "../../services/verificationService";

function AccountEmailSetting(props) {
  if (isEmptyScObj(props)) {
    return null;
  } else {
    return <AccountEmailSettingMain {...props} />;
  }
}
function AccountEmailSettingMain(props) {
  const [emailError, setEmailError] = useState(null);
  const [changeEmailOpened, setChangeEmailOpened] = useState(false);
  const [resetPasswordOpened, setResetPasswordOpened] = useState(false);
  const [emailEntered, setEmailEntered] = useState(null);
  const [emailEnteredIsValid, setEmailEnteredIsValid] = useState(true);
  const [changeEmailButtonIsDisabled, setChangeEmailButtonIsDisabled] = useState(true);
  const [verificationMethod, setVerificationMethod] = useState(null);
  const [verifyMethodSuccess, setVerifyMethodSuccess] = useState(false);
  const {
    lang,
    user,
    logout,
    resetPassword,
    verifyPhoneNumberForm,
    verifyEmailForm,
    selectVerificationMethodModal,
    fields: { headingTypeEmail, headingBodyEmail, subHeadingTypeEmail, subHeadingBodyEmail, bodyEmail, emailLabel, emailInfoMessage, emailWarningMessage, emailMissingMessage, emailInUseMessage, ctaNameChangeEmail, ctaTypeChangeEmail, colorSchemeChangeEmail, iconNameChangeEmail }
  } = props;
  const onEmailFocus = evt => {
    setEmailError(null);
  };
  const onEmailChanged = (evt, isValid) => {
    setEmailEntered(evt.target.value);
    setEmailEnteredIsValid(isValid);
    if (!isValid) {
      setEmailError(emailWarningMessage.value);
    } else {
      setEmailError(null);
    }
    setChangeEmailButtonIsDisabled(false);
  };

  const onSubmitEmailChange = async evt => {
    if (!emailEntered) {
      setEmailError(emailMissingMessage.value);
      return;
    }
    if (emailEntered === user?.email) {
      setEmailError(emailInUseMessage.value);
      return;
    }
    if (!emailEnteredIsValid) {
      setEmailError(emailWarningMessage.value);
      return;
    }
    const res = await api.email
      .check(
        {
          email: emailEntered
        },
        null
      )
      .catch(ex => {
        switch (ex.code) {
          case "USER_CUSTOMER_0008":
            setEmailError(emailInUseMessage.value);
            break;
          default:
            setEmailError(emailWarningMessage.value);
        }
      });
    if (res) {
      setChangeEmailButtonIsDisabled(true);
      setChangeEmailOpened(true);
    }
  };
  const emailInputProps = {
    label: emailLabel.value,
    showError: emailError !== null,
    infoMessage: emailInfoMessage.value,
    warningMessage: emailError,
    type: "email",
    onChange: (evt, isValid) => onEmailChanged(evt, isValid),
    onFocus: evt => onEmailFocus(evt)
  };
  const hideResetPassword = evt => {
    setResetPasswordOpened(false);
    setChangeEmailButtonIsDisabled(false);
  };
  const resetPasswordProps = {
    open: resetPasswordOpened,
    onCloseClicked: hideResetPassword,
    isInConfirmationStep: false,
    sendResetPasswordLink: async (evt, data) => {
      await sendResetPasswordLinkToEmail(lang, data.email);
    },
    ...resetPassword
  };
  const ctaChangeEmail = {
    ctaType: ctaTypeChangeEmail,
    buttonText: ctaNameChangeEmail.value,
    colorScheme: colorSchemeChangeEmail,
    iconName: iconNameChangeEmail,
    isDisabled: changeEmailButtonIsDisabled,
    callback: evt => onSubmitEmailChange(evt)
  };
  const verificationMethods = getVerificationMethods(user);
  const verificationModalProps = {
    user,
    fields: verifyPhoneNumberForm?.fields?.modalChangePhoneNumber?.fields,
    verificationMethods,
    verificationMethod,
    setVerificationMethod,
    verifyMethodSuccess,
    setVerifyMethodSuccess,
    open: changeEmailOpened,
    selectVerificationMethodModal,
    onCloseClicked: evt => {
      setChangeEmailOpened(false);
      setChangeEmailButtonIsDisabled(false);
      setVerificationMethod(null);
      setVerifyMethodSuccess(false);
    },
    verifyEmailForm,
    emailEntered
  };
  return (
    <div className="section">
      <Heading type={headingTypeEmail} typographyClass="type-h3" html={headingBodyEmail} />
      <Heading type={subHeadingTypeEmail} typographyClass="type-h3" html={subHeadingBodyEmail} />
      <BodyText html={bodyEmail.value} className="form-section-builder-section-body" />
      <Input autocomplete="email" name="email" {...emailInputProps} />
      <SuperButton {...ctaChangeEmail} />
      {verificationModalProps && verificationModalProps.verifyEmailForm && <SelectVerificationMethodModal type="emailChange" {...verificationModalProps} />}
      <ResetPassword {...resetPasswordProps} />
    </div>
  );
}

const mapStateToProps = state => ({
  user: selectUserState(state)
});
const mapDispatchToProps = dispatch => ({
  logout: () => dispatch({ type: LOGOUT })
});
export default connect(mapStateToProps, mapDispatchToProps)(AccountEmailSetting);
